export const isTopApp = (): boolean => {
  //iframed instance of ula has name "ulaIframe"
  return window.name === '';
};
